import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Navbar } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import Header from '../../Layout/Header';
import BsAlert from "../../Utils/BsAlert";
import { getEndpointUrl } from "../../Utils/Common";
import { HiArrowLeft } from 'react-icons/hi';
import SidebarMenu from '../../Layout/SidebarMenu';

const ChangeProfile = () => {
    const [isLoading, setLoading] = useState(false);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Field harus diisi'),
        username: Yup.string().required('Field harus diisi'),
        phone: Yup.string().required('Field harus diisi'),
        email: Yup.string().email(),
        password: Yup.string(),
        confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Konfirmasi password tidak sama!')
    });

    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    useEffect(() => {
        let defaultValues = {};
        defaultValues.name = userLogin.name;
        defaultValues.email = userLogin.email;
        defaultValues.phone = userLogin.phone;
        defaultValues.username = userLogin.username;
        reset({ ...defaultValues });

        localStorage.setItem('knowLogin', JSON.stringify(userLogin));
        
    }, [userLogin]);

    const onSubmit = data => {

        setLoading(true);

        fetch(getEndpointUrl() + `/users/${userLogin.id}`, {
            method: "PUT",
            body: new URLSearchParams({
                name: data.name,
                username: data.username,
                email: data.email,
                phone: data.phone,
                password: data.password,
                user_id: userLogin.id
            }),
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status == 'ok') {
                setUserLogin(json.results.data);

                toast.success("Yay, Perubahan berhasil disimpan.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };

    return (
        <>
            <Helmet>
                <title>Ubah Profil</title>
            </Helmet>
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Akun Saya</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline">
                <Header />
            </div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Container className="mt-5 mb-5">
                <ToastContainer position="top-end" className="p-3"></ToastContainer>
                    <Row>
                        <Col md={12}>
                            <strong>Ubah Profil</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <BsAlert />
                        </Col>
                    </Row>
                    <Row className="mt-3 mb-3">
                        <Col md={6} sm={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nama pengguna</Form.Label>
                                <Form.Control type="text" {...register("name")} isInvalid={errors.name ? true : false} autoComplete="off" />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label>Username</Form.Label>
                                <Form.Control type="text" {...register("username")} isInvalid={errors.username ? true : false} autoComplete="off" />
                            </Form.Group>
                            <Form.Group className="mb-3 pt-3">
                                <Form.Label>No Handphone</Form.Label>
                                <Form.Control type="text" {...register("phone")} isInvalid={errors.phone ? true : false} autoComplete="off" />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Alamat E-mail</Form.Label>
                                <Form.Control type="text" {...register("email")} isInvalid={errors.email ? true : false} autoComplete="off" />
                            </Form.Group>
                        </Col>
                        <Col md={6} sm={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Password login</Form.Label>
                                <Form.Control type="password" {...register("password")} isInvalid={errors.password ? true : false} autoComplete="off" />
                                <Form.Text className="text-muted fs-13 clearfix">Kosongkan untuk tidak mengganti password.</Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Konfirmasi password login</Form.Label>
                                <Form.Control type="password" {...register("confirmPassword")} isInvalid={errors.confirmPassword ? true : false} autoComplete="off" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={12} className="d-flex justify-content-end">
                            <Link onClick={() => navigate(-1)} title="Batal" className="btn btn-secondary me-3">Batal</Link>
                            <Button type="submit" disabled={isLoading}>{isLoading ? "Mengirim data..." : "Simpan Perubahan"}</Button>
                        </Col>
                    </Row>
                </Container>
            </Form>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
        </>
    );
}

export default ChangeProfile;